import * as React from 'react';
import { ReactElement } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../../../shared/ui/button';
import { ScreenSize } from '../../hooks/use_resize';
import Close from '../icons/close';

export interface ModalProps {
  className?: string;
  children?: ReactElement | ReactElement[];
  open: boolean;
  onClose: Function;
  title?: string | ReactElement;
  size?: ScreenSize;
  titleClassName?: string;
  bodyClassName?: string;
  bodyRef?: any;
  overlayClassName?: string;
  bodyProps?: any;
  footer?: ReactElement | ReactElement[];
  backdrop?: boolean;
  backdropClosable?: boolean;
  backdropProps?: React.HTMLAttributes<HTMLDivElement>;
}

export const Modal: React.FC<ModalProps> = (props) => {
  if (!props.open) return;

  const { backdrop = true, backdropClosable = true, backdropProps = {} } = props;

  return createPortal(
    <>
      <div
        className={`modal__overlay ${props.overlayClassName} ${!backdrop ? 'modal__overlay--hidden' : ''}`}
        onMouseDown={backdropClosable ? props.onClose : undefined}
        {...backdropProps}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          className={`modal__wrapper ${props.className} modal__wrapper-size_${props.size ?? 'sm'}`}
        >
          <div className={`modal__title ${props.titleClassName ?? ''}`}>
            <div className={'modal__title_content'}>{props.title}</div>
            <Button onClick={props.onClose} icon={<Close />} />
          </div>
          <div className={`modal__body ${props.bodyClassName ?? ''}`} ref={props.bodyRef} {...props.bodyProps}>
            {props.children}
          </div>
          {props.footer && <div className={'modal__footer'}>{props.footer}</div>}
        </div>
      </div>
    </>,
    document.body
  );
};
